module.exports = __webpack_public_path__ + "img/invite-patients-button-fr.b5019f8c.png";